import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleCaseBr'
})
export class TitleCaseBrPipe extends TitleCasePipe implements PipeTransform {
  siglasDosEstados: string[] = ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS',
    'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'
  ];

  palavrasIgonaradas: string[] = ['a', 'e', 'da', 'de']; // Strings que não serão modificadas.

  constructor() {
    super();
  }

  transform(value: any, ...args: any[]): any {
    const property = args[0];
    if (typeof value === 'string') {
      return super.transform(value);
    } else {
      return null;
    }
  }



}
